<template>
  <div class="body">
    <!--    <el-tabs v-model="loginMethod" class="loginContainer">-->
    <!--      <el-tab-pane class="tab-label" name="QRcode">-->
    <!--        <template #label><span class="tab-label">扫码登录</span></template>-->
    <!--        <img :src="weChatQRCode" style="height: 200px;width: 200px;" alt="qrcode"/>-->
    <!--        &lt;!&ndash;        <div id="login_container" v-if="weChatCode ===undefined"></div>&ndash;&gt;-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane name="code">-->
    <!--        <template #label><span class="tab-label">验证码登录</span></template>-->
    <!--        <el-form :rules="rules" ref="loginCodeForm" :model="loginCodeForm" style="margin-top: 20px">-->
    <!--          <el-form-item>新用户登录后将自动创建账号</el-form-item>-->
    <!--          <el-form-item prop="userName">-->
    <!--            <el-input type="text" v-model="loginCodeForm.userName" size="large" placeholder="用户名(手机号)">-->
    <!--            </el-input>-->
    <!--          </el-form-item>-->
    <!--          <slideVerify style="margin-top: 10px" :showWidth="280" :blockWidth="20" @success="onVerifySuccessCode">-->
    <!--          </slideVerify>-->
    <!--          <el-form-item style="margin-top: 10px" v-show="codeShow===true" prop="code">-->
    <!--            验证码-->
    <!--            <el-input type="text" v-model="loginCodeForm.code" size="large" style="width: 45%">-->
    <!--            </el-input>-->
    <!--            <el-button :disabled="countdown > 0" style="margin-left: 10px"-->
    <!--                       @click="startCountdown(loginCodeForm.userName)" type="primary">-->
    <!--              {{ countdown > 0 ? `${countdown}秒后重试` : '点击获取' }}-->
    <!--            </el-button>-->
    <!--          </el-form-item>-->
    <!--          <el-checkbox v-model="loginCodeForm.legalAgree" class="loginRemember">已阅读并同意-->
    <!--            <span @click="openLegalAgree" style="font-size: 14px;color:dodgerblue">平台服务协议-->
    <!--            </span>-->

    <!--          </el-checkbox>-->
    <!--          <el-button type="primary" style="width:100%;margin-top: 10px" size="large" @click="submitCodeLogin">登录-->
    <!--          </el-button>-->
    <!--        </el-form>-->
    <!--      </el-tab-pane>-->

    <!--      <el-tab-pane class="tab-label" name="qrCode">-->
    <!--        <template #label><span class="tab-label">扫码登录</span></template>-->
    <!--      </el-tab-pane>-->

    <!--      <el-tab-pane name="password">-->
    <!--        <template #label><span class="tab-label">密码登录</span></template>-->
    <!--        <el-form :rules="rules" ref="loginForm" :model="loginForm" style="width: 95%;margin-top: 20px">-->
    <!--          <el-form-item prop="userName">-->
    <!--            <el-input type="text" v-model="loginForm.userName" size="large" placeholder="用户名(手机号)">-->
    <!--            </el-input>-->
    <!--          </el-form-item>-->
    <!--          <el-form-item prop="password">-->
    <!--            <el-input type="password" v-model="loginForm.password" size="large" placeholder="密码">-->
    <!--            </el-input>-->
    <!--          </el-form-item>-->
    <!--          <el-checkbox v-model="loginForm.isRememberPassword" class="loginRemember">记住密码</el-checkbox>-->
    <!--          <slideVerify @success="onVerifySuccess" style="margin-top: 10px" :showWidth="310" :blockWidth="20">-->
    <!--          </slideVerify>-->
    <!--          <el-form-item style="margin-top: 10px" v-show="codeShow===true" prop="code" label="验证码">-->
    <!--            <el-input type="text" v-model="loginForm.code" style="width: 45%">-->
    <!--            </el-input>-->
    <!--            <el-button :disabled="countdown > 0" @click="startCountdown(loginForm.userName)" type="primary">-->
    <!--              {{ countdown > 0 ? `${countdown}秒后重试` : '点击获取' }}-->
    <!--            </el-button>-->
    <!--          </el-form-item>-->
    <!--          <el-button type="primary" style="width:100%;margin-top: 10px;" @click="submitPasswordLogin" size="large">登录-->
    <!--          </el-button>-->
    <!--          <el-link style="font-size: small" @click="goDynamicCode()">忘记密码？</el-link>-->
    <!--          <p></p>-->
    <!--          <el-link style="font-size: small" href="/register">没有账号？注册一个新账号</el-link>-->
    <!--        </el-form>-->
    <!--      </el-tab-pane>-->
    <!--    </el-tabs>-->
  </div>
</template>

<script>
import {useRoute} from "vue-router/dist/vue-router";
import request from "../utils/request";
import router from "@/router";
import {ElMessage} from "element-plus";
// import slideVerify from "@/components/SlideVerify";
import {ref} from "vue";
import weChat from "@/utils/weChat";

const isTokenExpire = ref(true);
const weChatCode = ref('');

const loginUserId = localStorage.getItem("loginUserId");
const weChatQRCode = ref('');

async function getUserAuthorization(type) {
  await request.get('/userAuthorization/get', {
    params: {
      userId: loginUserId,
      type: type
    }
  })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        console.log("getUserAuthorization" + result.code)
        if (result.code === "200") {
          isTokenExpire.value = false;
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

async function getUserInfoWithCode(loginForm) {
  await request.post('/login/code', {
        userName: loginForm.userName
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给items
    if (result.code === "200") {
      localStorage.setItem("userToken", result.token);
      localStorage.setItem('loginNickName', result.nickName);
      localStorage.setItem('loginUserId', result.id);
      localStorage.setItem('loginUserName', loginForm.userName);
      localStorage.setItem('deviceId', result.deviceId);
      ElMessage.success("登录成功");
    } else {
      ElMessage.warning(result.msg);
      // router.push("/login");
    }
  }).catch(error => {
    console.log("loginPage error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
    router.push("/login");
  });

}

//
// async function getUserInfo(loginForm, type) {
//   await request.post('/login/', {
//         userName: loginForm.userName,
//         password: loginForm.password
//       },
//       {
//         headers: {
//           'Content-Type': 'application/json;charset=utf-8'
//         }
//       }).then(response => {
//     const result = response.data; // 将接口返回的数据赋值给items
//     if (result.code === "200") {
//       if (type === 'login') {
//         localStorage.setItem("userToken", result.token);
//         localStorage.setItem('loginNickName', result.nickName);
//         localStorage.setItem('loginUserId', result.id);
//         localStorage.setItem('loginUserName', loginForm.userName);
//         ElMessage.success("登录成功");
//       }
//     } else {
//       ElMessage.warning(result.msg);
//       // router.push("/login");
//     }
//   }).catch(error => {
//     console.log("loginPage error:" + error);
//     // ElMessage.error("系统异常，请联系管理员");
//     router.push("/login");
//   });
// }


async function sendPhoneConfirmCode(userName) {
  await request.post(
      '/register/generatePhoneConfirmCode',
      {
        "userName": userName,
        "type": "login"
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200" && result.msg !== "") {
          ElMessage.error(result.msg);
        } else {
          ElMessage.warning("验证码已发送，10分钟内有效，请通过手机查收");
        }
      }).catch(error => {
        console.error("sendPhoneConfirmCode error:" + error);
        // ElMessage.info("系统异常，请联系管理员");
      });
}

let phoneConfirmCodeSuccess = false;

async function checkPhoneConfirmCode(code, userName) {
  await request.get('/register/checkPhoneConfirmCode',
      {
        params: {
          phone: userName,
          code: code,
          type: 'login'
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code !== "200" && result.msg !== "") {
      ElMessage.error(result.msg);
    } else {
      ElMessage.success("验证码校验通过");
      phoneConfirmCodeSuccess = true;
    }
  }).catch(error => {
    console.error("checkPhoneConfirmCode error:" + error);
    // ElMessage.info("系统异常，请联系管理员");
  });
}

const loginMethod = ref('QRcode');
export default {
  name: "LoginPage",
  // components: {slideVerify},
  data() {
    return {
      // loginForm: {
      //   userName: "",
      //   password: "",
      //   isRememberPassword: true,
      //   code: ""
      // },
      loginCodeForm: {
        userName: "",
        code: "",
        legalAgree: false
      },
      rules: {
        userName: [{required: true, message: "请输入用户名", trigger: "blur"}, {
          min: 11,
          max: 11,
          message: '长度为11位的手机号数字',
          trigger: 'blur'
        }
        ],
      },
      codeShow: false,
      countdown: 0, // 初始倒计时秒数
      timer: null, // 计时器
      loginMethod: loginMethod,
      weChatCode: weChatCode,
      weChatQRCode: weChatQRCode
    }
  },
  async created() {
    const route = useRoute()
    weChatCode.value = route.query.code;
    console.log("weChatCode=" + weChatCode.value);

    const loginFlag = localStorage.getItem("loginFlag");
    console.log(loginFlag);

    if (loginUserId !== '' && loginFlag) {
      await getUserAuthorization.call(this, "subject");
      console.log("isTokenExpire=" + isTokenExpire.value);
      if (!isTokenExpire.value) {
        console.log("setStorageSync loginFlag");
        localStorage.setItem('loginFlag', true);
        console.log(localStorage.getItem("loginFlag"));
        ElMessage.success("登录成功");
        await router.push({path: "/"});
        location.reload();
        return;
      }
    }
    if (weChatCode.value !== null && weChatCode.value !== '' && weChatCode.value !== undefined) {
      await weChat.loginFromWechatQrCode(weChatCode.value);
      console.log("loginFromWechatQrCode end");
      setTimeout(async () => {
        await router.push({path: "/"});
        console.log("to home");
      },2000);
      // location.reload();
    } else {
      ElMessage.info("正在生成二维码,请稍后...");
      weChat.getLoginScanCode();
      // weChat.getLoginScanCode();

    }

    this.loadSavedCodeLogin();
    // this.loadSavedLogin();
  },
  methods: {
    // onVerifySuccess() {
    //   this.$refs.loginForm.validate(async (valid) => {
    //     if (valid) {
    //       await getUserInfo(this.loginForm, "check");
    //       this.codeShow = true;
    //     }
    //   });
    // },
    onVerifySuccessCode() {
      this.$refs.loginCodeForm.validate(async (valid) => {
        if (valid) {
          this.codeShow = true;
        }
      })
    },
    // submitPasswordLogin() {
    //   this.$refs.loginForm.validate(async (valid) => {
    //     if (valid) {
    //       await checkPhoneConfirmCode(this.loginForm.code, this.loginForm.userName);
    //       if (phoneConfirmCodeSuccess) {
    //         // submit to login
    //         await getUserInfo(this.loginForm, "login");
    //         // 记住密码
    //         if (this.loginForm.isRememberPassword) {
    //           localStorage.setItem('loginFormInfo', JSON.stringify(this.loginForm));
    //         } else {
    //           localStorage.removeItem('loginFormInfo');
    //         }
    //         // 跳转到主页
    //         await router.push({path: "/"});
    //       }
    //     } else {
    //       this.$message.error('登录出错请重新输入');
    //       return false;
    //     }
    //   });
    // },
    // loadSavedLogin() {
    //   const savedLoginInfo = localStorage.getItem('loginFormInfo');
    //   if (savedLoginInfo) {
    //     const {userName, password} = JSON.parse(savedLoginInfo);
    //     this.loginForm.userName = userName;
    //     this.loginForm.password = password;
    //     this.loginForm.isRememberPassword = true;
    //   }
    // },
    openLegalAgree() {
      // 这里的 URL 应该替换为你想要打开的页面的 URL
      router.push({path: "/legalAgree"});
    },
    loadSavedCodeLogin() {
      let userName = localStorage.getItem('loginUserName');
      if (userName) {
        this.loginCodeForm.userName = userName;
        this.loginCodeForm.legalAgree = true;
      }
    },
    async startCountdown(userName) {
      if (this.timer) return;
      if (userName === "" || userName.match("^1[3-9]\\\\d{9}$")) {
        this.$message.error("手机号不合法，请重新输入");
        return;
      } else {
        this.countdown = 60; // 设置倒计时总时间
        await sendPhoneConfirmCode(userName);
      }
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    goDynamicCode() {
      loginMethod.value = "code";
    },
    submitCodeLogin() {
      this.$refs.loginCodeForm.validate(async (valid) => {
        if (valid) {
          if (!this.loginCodeForm.legalAgree) {
            ElMessage.error("请勾选同意协议")
            return false;
          }
          await checkPhoneConfirmCode(this.loginCodeForm.code, this.loginCodeForm.userName);
          if (phoneConfirmCodeSuccess) {
            // submit to login
            await getUserInfoWithCode(this.loginCodeForm);
            // 跳转到主页
            await router.push({path: "/"});
            location.reload();
          }
        } else {
          this.$message.error('登录出错,请重新输入');
          return false;
        }
      });
    },
  }
}


</script>

<style scoped>

.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  text-align: left;
  margin: auto;
  margin-top: 120px;
  width: 370px;
  padding: 20px 30px 20px 30px;
  background: aliceblue;
  border: 1px solid blue;
  box-shadow: 0 0 25px darkblue;
}

.loginRemember {
  text-align: left;
  margin: 10px 0px 15px 0px;
}

.body {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/picture/loginBackground.jpg');
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  display: flex;
}

/*.el-form {*/
/*  width: 350px;*/
/*  height: auto;*/
/*  margin: 100px auto;*/
/*}*/

.tab-label {
  font-size: 20px;
}

.el-input {
  --el-input-border-color: darkgray !important;
  --el-input-text-color: black !important;
}

</style>
